import { calculatorChapter } from './calculatorChapter';
import { chartsChapter } from './chartsChapter';
import { codexAndToolsChapter } from './codexAndToolsChapter';
import { factoryBasicsChapter } from './factoryBasicsChapter';
import { factoryLinkingChapter } from './factoryLinkingChapter';
import { gamesAndSyncChapter } from './gamesAndSyncChapter';
import { mapChapter } from './mapChapter';
import { notesChapter } from './notesChapter';
import type { TutorialChapter } from './types';

export const tutorialChapters: TutorialChapter[] = [
  gamesAndSyncChapter,
  factoryBasicsChapter,
  calculatorChapter,
  factoryLinkingChapter,
  chartsChapter,
  mapChapter,
  notesChapter,
  codexAndToolsChapter,
];

export const tutorialChaptersById: Record<string, TutorialChapter> =
  Object.fromEntries(tutorialChapters.map(c => [c.id, c]));

export const tutorialTotalMinutes = tutorialChapters.reduce(
  (total, c) => total + c.estimatedMinutes,
  0,
);

export function formatEstimatedMinutes(minutes: number): string {
  return `~${minutes} min`;
}

export type { TutorialChapter };
